var render, staticRenderFns
import script from "./DoughnutChart.vue?vue&type=script&lang=js&"
export * from "./DoughnutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38bd3783')) {
      api.createRecord('38bd3783', component.options)
    } else {
      api.reload('38bd3783', component.options)
    }
    
  }
}
component.options.__file = "src/modules/charts/DoughnutChart.vue"
export default component.exports